export const CREATE_ARCHITECTUREACTIVITIES = "CREATE_ARCHITECTUREACTIVITIES";   
export const RETRIEVE_ARCHITECTUREACTIVITIES = "RETRIEVE_ARCHITECTUREACTIVITIES";
export const RETRIEVESINGLE_ARCHITECTUREACTIVITIES = "RETRIEVESINGLE_ARCHITECTUREACTIVITIES";
export const UPDATE_ARCHITECTUREACTIVITIES = "UPDATE_ARCHITECTUREACTIVITIES";   
export const DELETE_ARCHITECTUREACTIVITIES = "DELETE_ARCHITECTUREACTIVITIES";   
